import { render } from "./ViewCustomerSegmentModal.vue?vue&type=template&id=6f0e7454&scoped=true"
import script from "./ViewCustomerSegmentModal.vue?vue&type=script&lang=js"
export * from "./ViewCustomerSegmentModal.vue?vue&type=script&lang=js"

import "./ViewCustomerSegmentModal.vue?vue&type=style&index=0&id=6f0e7454&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0e7454"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
